module.exports = __webpack_public_path__ + "img/photo-46.4196329b.webp";